// extracted by mini-css-extract-plugin
export default {"box":"NewBox_box__pqA7t","description":"NewBox_description__p0gp5","title":"NewBox_title__mtfEB","icon":"NewBox_icon__wM+JM"};